import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';
import getters from './getters';

const state = {
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
